import {Component} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {environment} from './../environments/environment';
import {AuthService} from './api/auth.service';
import {BannerService} from './shared/services/banner.service';
import {filter} from 'rxjs';
import {quietDataTableAlerts} from './shared/rana-datatable-defaults';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent {

    title = 'Rajput Association Of North America';

    roles = ['NECAdmin', 'ChapterAdmin', 'User', 'Guest'];
    selectedRole: string = '';

    constructor(private authService: AuthService, private router: Router, public bannerService: BannerService) {
        console.log("Environment used:  " + environment.production); // Logs false for development environment
        quietDataTableAlerts();
    }

    ngOnInit(): void {
        this.router.events
            .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe(event => {
                // Landing page notification banner is shown only on the public home page ('/', which
                // redirects to '/home').
                this.bannerService.showBanner = event.urlAfterRedirects === '/home';
            });
    }

    setRole(role: string) {
        this.selectedRole = role;
        this.authService.setRole(role);
    }

    canAdd(): boolean {
        return this.authService.hasRole('NECAdmin');
    }

    canEdit(): boolean {
        return this.authService.hasRole('NECAdmin');
    }

    canView(): boolean {
        return this.authService.hasAnyRole(['Admin', 'User']);
    }

}
